import React from 'react';
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
import '../Contactus/Place.css'; 

const Place = () => {
  const callAdmin = () => {
    window.location.href = 'tel:+919220347091'; // replace with real number
  };
  const handleEmailClick = () => {
    window.location.href = 'mailto:info@shreeverevents.com';
  };
  return (
    <div className="details">
      <h1 data-aos="fade-down">Contact Details</h1>
      <div className="full-detail">
        <div className="detail-section" data-aos="zoom-out" onClick={callAdmin}>
          <FaPhoneAlt className="iconp" />
          <div className="detail-info">
            <h3>Phone:</h3>
            <p>+91 922-034-7091</p>
          </div>
        </div>

        <div className='line'></div>

        <div className="detail-section" data-aos="zoom-out">
          <FaMapMarkerAlt className="iconp" />
          <div className="detail-info">
            <h3>Address:</h3>
            <p>Sector-62, Noida, Uttar Pradesh, India</p>
          </div>
        </div>

        <div className='line'></div>

        <div className="detail-section" data-aos="zoom-out" onClick={handleEmailClick}>
          <FaEnvelope className="iconp" />
          <div className="detail-info">
            <h3>Email:</h3>
            <p>info@shreeverevents.com</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Place;
